import script from "./FeedbackPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackPopup.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackPopup.vue?vue&type=style&index=0&id=851bc7e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-851bc7e8"]])

export default __exports__